import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "../App.css";

export default function ContactUsPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    category: "general",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, you would send this to your backend
    console.log("Contact form submitted:", formData);
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
        category: "general",
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <button onClick={() => navigate(-1)} className="back-button">
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <h1>Contact Us</h1>
      </div>

      <div className="settings-container">
        {/* Contact Information */}
        <div className="settings-section">
          <h3 className="settings-section-title">Get in Touch</h3>
          <p style={{ color: "#64748b", marginBottom: "2rem" }}>
            Have a question or need assistance? We're here to help! Choose your
            preferred method of contact below.
          </p>

          <div className="contact-methods">
            <div className="contact-card">
              <div className="contact-icon">
                <span className="material-symbols-outlined">email</span>
              </div>
              <h4>Email Support</h4>
              <p>support@physiokea.com</p>
              <p className="contact-time">Response within 24 hours</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <span className="material-symbols-outlined">phone</span>
              </div>
              <h4>Phone Support</h4>
              <p>+1 (555) 123-4567</p>
              <p className="contact-time">Mon-Fri, 9 AM - 5 PM EST</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <span className="material-symbols-outlined">chat</span>
              </div>
              <h4>Live Chat</h4>
              <p>Available on website</p>
              <p className="contact-time">Mon-Fri, 9 AM - 5 PM EST</p>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="settings-section">
          <h3 className="settings-section-title">Send Us a Message</h3>
          
          {submitted ? (
            <div className="success-message">
              <span className="material-symbols-outlined">check_circle</span>
              <h3>Message Sent Successfully!</h3>
              <p>
                Thank you for contacting us. We'll get back to you as soon as
                possible.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">
                  <span className="material-symbols-outlined">person</span>
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">
                  <span className="material-symbols-outlined">email</span>
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="category">
                  <span className="material-symbols-outlined">category</span>
                  Category *
                </label>
                <select
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                >
                  <option value="general">General Inquiry</option>
                  <option value="technical">Technical Support</option>
                  <option value="billing">Billing Question</option>
                  <option value="feature">Feature Request</option>
                  <option value="bug">Report a Bug</option>
                  <option value="feedback">Feedback</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="subject">
                  <span className="material-symbols-outlined">subject</span>
                  Subject *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Brief description of your inquiry"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  <span className="material-symbols-outlined">message</span>
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Please provide details about your inquiry..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                <span className="material-symbols-outlined">send</span>
                Send Message
              </button>
            </form>
          )}
        </div>

        {/* Additional Resources */}
        <div className="settings-section">
          <h3 className="settings-section-title">Additional Resources</h3>
          
          <div className="resource-cards">
            <div
              className="resource-card"
              onClick={() => navigate("/help")}
              style={{ cursor: "pointer" }}
            >
              <span className="material-symbols-outlined">help_center</span>
              <h4>Help Center</h4>
              <p>Browse our comprehensive documentation and FAQs</p>
            </div>

            <div
              className="resource-card"
              onClick={() => navigate("/privacy-security")}
              style={{ cursor: "pointer" }}
            >
              <span className="material-symbols-outlined">policy</span>
              <h4>Privacy Policy</h4>
              <p>Learn how we protect your data and privacy</p>
            </div>
          </div>
        </div>

     
      </div>
    </div>
  );
}
